import React, { FC } from 'react';
import { OptionFieldProps } from '../../common/OptionField';
import { OptionFieldWithAnalytics } from '../../common/OptionFieldWithAnalytics';

export const ExportOptionField: FC<OptionFieldProps> = (props) => <OptionFieldWithAnalytics {...props} eventAction="edit export" />;
